@use '@lib/assets/styles/main.scss' as *;
.wrapPrimary {
  padding: 24px 0;
}

.wrapSecondary {
  padding: 24px 0;
}

.title {
  margin-bottom: 32px;
}

.action {
  text-align: right;
}

.form {
  margin-bottom: -24px;
}

.avatarBlock {
  @extend .col-xs-12;
}

.passwordRow {
  @include responsive($md1, null) {
    .title {
      margin-bottom: 0;
    }
  }
  @include responsive($md1) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.forgotPassword {
  text-align: right;
  a {
    line-height: 45px;
    height: 45px;
  }
}

.profileView {
  & > * + * {
    margin-top: 16px;
  }
  & > * {
    & > * + * {
      margin-top: 8px;
    }
  }
}

.chipsRow {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

.profileViewLabel {
  color: $gray500;
}
